"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _TextField = _interopRequireDefault(require("../TextField/TextField"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

var determineColor = function determineColor(_ref) {
  var theme = _ref.theme,
      hoverColor = _ref.hoverColor;
  var splitColor = (hoverColor || "dark.5").split(".");
  if (!theme || !theme.colors) return "none";
  return "" + theme.colors[splitColor[0]][splitColor[1]];
};

var DropdownWrapper = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "ResponsiveSearch__DropdownWrapper",
  componentId: "mppjna-0"
})(["overflow-y:auto;-webkit-overflow-scrolling:touch;& >:last-child{padding-bottom:", "px;}@media only screen and (min-width:", "px){& >:last-child{padding-bottom:", "px;}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.space[2];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints[0];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space[1];
});

var ClickableLabel = _styledComponents["default"].label.withConfig({
  displayName: "ResponsiveSearch__ClickableLabel",
  componentId: "mppjna-1"
})(["padding-top:", "px;padding-bottom:", "px;&:hover{cursor:pointer;background-color:", ";border-radius:2px;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.space[1];
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.space[1];
}, determineColor);

var ResponsiveSearch = function ResponsiveSearch(_ref7) {
  var _ref7$options = _ref7.options,
      options = _ref7$options === void 0 ? [] : _ref7$options,
      onChangeCallback = _ref7.onChangeCallback,
      _ref7$width = _ref7.width,
      width = _ref7$width === void 0 ? 1 : _ref7$width,
      _ref7$height = _ref7.height,
      height = _ref7$height === void 0 ? 60 : _ref7$height,
      label = _ref7.label,
      _ref7$helperText = _ref7.helperText,
      helperText = _ref7$helperText === void 0 ? "Start typing and select from the list" : _ref7$helperText,
      _ref7$dropdownWidth = _ref7.dropdownWidth,
      dropdownWidth = _ref7$dropdownWidth === void 0 ? width : _ref7$dropdownWidth,
      id = _ref7.id,
      isLoading = _ref7.isLoading,
      _ref7$maxHeight = _ref7.maxHeight,
      maxHeight = _ref7$maxHeight === void 0 ? 200 : _ref7$maxHeight,
      hoverColor = _ref7.hoverColor,
      selectCallback = _ref7.selectCallback,
      showClearButton = _ref7.showClearButton,
      _ref7$initialSearchTe = _ref7.initialSearchTerm,
      initialSearchTerm = _ref7$initialSearchTe === void 0 ? "" : _ref7$initialSearchTe,
      disabled = _ref7.disabled,
      _ref7$autoComplete = _ref7.autoComplete,
      autoComplete = _ref7$autoComplete === void 0 ? "off" : _ref7$autoComplete,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref7, ["options", "onChangeCallback", "width", "height", "label", "helperText", "dropdownWidth", "id", "isLoading", "maxHeight", "hoverColor", "selectCallback", "showClearButton", "initialSearchTerm", "disabled", "autoComplete"]);

  var _useState = (0, _react.useState)(initialSearchTerm),
      searchTerm = _useState[0],
      setSearchTerm = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      showDropdown = _useState2[0],
      setShowDropdown = _useState2[1];

  var handleSelect = function handleSelect(option) {
    setShowDropdown(false);
    setSearchTerm(option);
    if (selectCallback) selectCallback(option);
  };

  var handleChange = function handleChange(e) {
    setSearchTerm(e.target.value);
    setShowDropdown(true);
    if (selectCallback) selectCallback(e.target.value);
    if (onChangeCallback) onChangeCallback(e.target.value);
  };

  var hideDropdownOnBlur = function hideDropdownOnBlur(e) {
    var isTargetDropdown = !!(e.relatedTarget && e.relatedTarget.className.match(/ResponsiveSearch__DropdownWrapper/g).length > 0);

    if (!isTargetDropdown) {
      setShowDropdown(false);
    }
  };

  return _react["default"].createElement(_Flex["default"], {
    position: "relative",
    onBlur: hideDropdownOnBlur
  }, _react["default"].createElement(_TextField["default"], (0, _extends2["default"])({
    id: id,
    onChange: handleChange,
    value: searchTerm,
    width: 1 / 1,
    height: height,
    autoComplete: autoComplete
  }, props)), showDropdown && _react["default"].createElement(DropdownWrapper, {
    tabIndex: 0,
    flexDirection: "column",
    width: dropdownWidth,
    p: 3,
    bg: "light.0",
    zIndex: "2000",
    elevation: 2,
    borderRadius: 4,
    maxHeight: maxHeight,
    position: "absolute",
    mt: height
  }, isLoading && _react["default"].createElement(_Spinner["default"], {
    py: 3,
    color: "primary.0",
    justifyContent: "center",
    width: 1 / 1
  }), !isLoading && options.map(function (option) {
    return _react["default"].createElement(ClickableLabel, {
      onClick: function onClick() {
        return handleSelect(option);
      },
      key: option,
      hoverColor: hoverColor
    }, _react["default"].createElement(_Text["default"], {
      px: 2
    }, option.name));
  })));
};

var _default = ResponsiveSearch;
exports["default"] = _default;